import _ from 'underscore';
import moment from 'moment';
import jQuery from 'jquery';
import Promise from 'bluebird';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';
import eventHeaderImagePic from '../../assets/images/header_placeholder.png';

function AddEventCtrl($scope, $timeout, $state, $stateParams, $q, sdkVenueService, eventService, imageService, tagService, sdkUtils, dateUtilsService, alertService, managementUserService, ERROR_MESSAGES, organizationService, urlService, TRACKING_EVENT_CATEGORIES, analyticsService, modalService, attributionSourceService, mapperService, formHelpersService, visibilityHelpersService, venueService, imgixService) { //eslint-disable-line
  if (!$scope.venue) throw new Error('venue is required');

  const vm = this;

  const currentUser = managementUserService.getCurrentUser();
  const currentUserOrganization = organizationService.getCurrentOrganization();

  //add methods to a passed in object so the called can hook into events having in this directive
  $scope.instance = $scope.instance || {};
  $scope.instance.nextStep = function () {
    let nextSectionNumber = 2;

    if (vm.currentSection === vm.sections.SETTINGS) {
      nextSectionNumber = 2;
    } else if (vm.currentSection === vm.sections.INVENTORY) {
      nextSectionNumber = 3;
    }

    return vm.nextSection(nextSectionNumber, vm.angularForm);
  };
  $scope.inventoryNoteOptions = {
    toolbar: [
      ['style', ['style']],
      ['style', ['bold', 'italic', 'underline']],
      ['fontsize', ['fontsize']],
      ['insert', ['link']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']]
    ],
    height: 140
  };
  /**
   * @param {Object} [options]
   * @param {Boolean} [options.publish]
   */
  $scope.instance.saveEvent = function (options) {
    if ($scope.instance.onSaving) {
      $scope.instance.onSaving();
    }

    return vm.saveEvent(vm.angularForm, null, options)
      .then(() => {
        if ($scope.instance.onSaved) {
          $scope.instance.onSaved(vm.eventForm);
        }
      })
      .catch(err => {
        if ($scope.instance.onError) {
          $scope.instance.onError(err);
        }
      });
  };
  vm.loading = true;
  vm.event = $scope.event;
  vm.venue = $scope.venue;
  vm.venueId = vm.venue.id;
  vm.editMode = !!vm.event;
  vm.TRACKING_EVENT_CATEGORIES = TRACKING_EVENT_CATEGORIES;
  vm.backTo = $stateParams.backTo;
  vm.descriptionOptions = {
    toolbar: [
      ['style', ['style']],
      ['style', ['bold', 'italic', 'underline']],
      ['fontsize', ['fontsize']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']]
    ]
  };
  vm.eventHeaderImagePic = eventHeaderImagePic;
  vm.sections = {
    SETTINGS: 'SETTINGS',
    INVENTORY: 'INVENTORY',
    DESIGN: 'DESIGN'
  };
  vm.currentSection = vm.sections.SETTINGS;
  vm.getEventImage = function () {
    if (!vm.eventForm || !vm.eventForm.primaryImage) return '';

    return imgixService.url(vm.eventForm.primaryImage, {
      width: 90,
      height: 90
    });
  };

  if (vm.editMode && $scope.section && vm.sections[$scope.section]) {
    vm.currentSection = vm.sections[$scope.section];
  }

  vm.sectionsValidityState = {};

  if (vm.editMode) {
    vm.eventForm = mapperService.mapEventToUI(vm.event);

    vm.sectionsValidityState[vm.sections.SETTINGS] = true;
    vm.sectionsValidityState[vm.sections.INVENTORY] = true;
    vm.sectionsValidityState[vm.sections.DESIGN] = true;
  } else {
    const eventDefaults = vm.venue.eventDefault || {};

    vm.eventForm = {
      isMapWidgetEnabled: eventDefaults.isMapWidgetEnabled
    };
  }

  vm.nextSection = function (nextSectionNumber, form, $event) {
    if ($event) $event.preventDefault();

    vm.submitted = true;

    if (nextSectionNumber === 1) {
      vm.currentSection = vm.sections.SETTINGS;
    } else if (nextSectionNumber === 2) {
      if (form.name.$error && form.name.$error.required) {
        if ($scope.scrollId) {
          const nameFieldEl = jQuery('.event-edit-name-field');

          jQuery($scope.scrollId)[0].scrollTop = nameFieldEl[0].offsetTop;
        }

        return null; //name field is required
      }

      vm.currentSection = vm.sections.INVENTORY;

      vm.sectionsValidityState[vm.sections.SETTINGS] = true; //mark the first step as valide
    }

    if ($scope.instance.onNextStep) {
      $scope.instance.onNextStep(nextSectionNumber);
    }

    return null;
  };

  vm.saveEvent = _saveEvent;
  // vm.unlinkEvent = _unlinkEvent;
  vm.tagTransform = _tagTransform;
  vm.updateDateEnd = function () {
    if (vm.eventForm.dateStart.isAfter(vm.eventForm.dateEnd)) {
      vm.eventForm.dateEnd = vm.eventForm.dateStart;
      vm.eventForm.dateEndUpdated = true;
    }
    if (vm.eventForm.enabledOn) {
      if (vm.eventForm.enabledOn.isAfter(vm.eventForm.dateStart)) {
        vm.eventForm.enabledOn = vm.eventForm.dateStart;
      }
    } else {
      vm.eventForm.enabledOn = vm.eventForm.dateStart;
    }
  };
  vm.updateDateStart = function () {
    if (vm.eventForm.dateEnd.isBefore(vm.eventForm.dateStart)) {
      vm.eventForm.dateStart = vm.eventForm.dateEnd;
      vm.eventForm.dateStartUpdated = true;
    }
  };
  vm.updatedEnabledOn = function () {
    if (!vm.eventForm.enabledOnTime) {
      vm.eventForm.enabledOnTime = '6:00 AM';
    }
  };

  vm.isVenuePublicOrPublished = function () {
    return visibilityHelpersService.isPublicOrPublished(vm.venue);
  };

  vm.isVenueOnTablelist = function (venue) {
    return visibilityHelpersService.isOnTablelist(venue);
  };

  vm.isVenuePublic = function (venue) {
    return visibilityHelpersService.isPublic(venue);
  };

  vm.isVenuePrivate = function (venue) {
    return visibilityHelpersService.isPrivate(venue);
  };

  const dataPromises = [
    _getTags(),
    _getAttributionSources()
  ];

  $q.all(dataPromises)
    .then(results => {
      vm.tags = results[0];
      vm.attributionSource = results[1];

      vm.userDefinedTags = [];
      vm.dressCodeOkTags = _.filter(vm.tags, tag => {
        return tag.key === 'DRESS_CODE_OK';
      });
      vm.dressCodeNotOkTags = _.filter(vm.tags, tag => {
        return tag.key === 'DRESS_CODE_NOT_OK';
      });
      vm.musicTags = _.filter(vm.tags, tag => {
        return tag.key === 'MUSIC';
      });

      // Editing
      if (vm.editMode) {
        if (vm.event.seoPathname) vm.tablelistUrl = urlService.getEventPublicPageUrl(vm.event.seoPathname, {});
        vm.eventForm.primaryImage = vm.eventForm.primaryImage;
      } else {
        vm.eventForm.date = $scope.date ? dateUtilsService.toUTCMomentWithoutTime($scope.date) : moment.utc();
        vm.eventForm.dateStart = vm.eventForm.date.clone();
        vm.eventForm.dateStartTime = '6:00 PM';
        vm.eventForm.dateEnd = vm.eventForm.date.clone().add(1, 'day');
        vm.eventForm.dateEndTime = '1:00 AM';
        vm.eventForm.enabledOn = moment();
        vm.eventForm.enabledOnTime = moment().format('h:mm A');
        vm.eventForm.enableRecurring = false;

        if (vm.isVenuePublicOrPublished()) {
          vm.eventForm.visibility = visibilityHelpersService.VISIBILITY_TYPES.PUBLISHED.value;
        } else {
          vm.eventForm.visibility = visibilityHelpersService.VISIBILITY_TYPES.PRIVATE.value;
          vm.eventForm.isPrivate = true;
        }

        if (vm.venue) {
          vm.eventForm.venue = vm.venue.id;

          if (vm.isVenueOnTablelist(vm.venue)) {
            vm.eventForm.enable = true;
            vm.eventForm.disableGuestList = true;
            vm.eventForm.disableReservation = true;
            vm.eventForm.enableTablelist = true;
            vm.eventForm.musicTags = _.filter(vm.venue.tags, tag => {
              return tag.key === 'MUSIC';
            });
            vm.eventForm.dressCodeOkTags = _.filter(vm.venue.tags, tag => {
              return tag.key === 'DRESS_CODE_OK';
            });
            vm.eventForm.dressCodeNotOkTags = _.filter(vm.venue.tags, tag => {
              return tag.key === 'DRESS_CODE_NOT_OK';
            });
            if (vm.venue.config && vm.venue.config.defaultPoster && vm.venue.config.defaultPoster.filename) {
              vm.eventForm.primaryImage = vm.venue.config.defaultPoster.filename;
            }
          } else {
            vm.eventForm.disableGuestList = false;
            vm.eventForm.disableReservation = false;
            vm.eventForm.enableTablelist = false;
          }
        }
      }

      vm.loading = false;
    });

  // ----------------------- private helpers ----------------------- //

  function _tagTransform(value) {
    const tag = {
      key: value,
      value: value
    };

    return tag;
  }

  /**
   * @return {Promise<Tag>}
   */
  function _getTags() {
    return tagService.list({})
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function _saveEvent(form, $event) {
    if (!form) throw new Error('_saveEvent() - form is required');
    if ($event) $event.preventDefault();

    vm.submitted = true;

    if (!form.$valid) {
      return Promise.reject(new Error('form is invalid'));
    }

    vm.savingEvent = true;

    const changedValues = formHelpersService.getChangedFormValues(form);

    // Manually determine if visibility value has changed.
    if (!vm.editMode || (vm.eventForm.visibility !== vm.event.visibility)) {
      changedValues.visibility = Number(vm.eventForm.visibility);
    }

    //always map these because UI-select doesn't mark as changed when removing tags
    changedValues.performers = vm.eventForm.performers;
    changedValues.musicTags = vm.eventForm.musicTags;
    changedValues.dressCodeOkTags = vm.eventForm.dressCodeOkTags;
    changedValues.dressCodeNotOkTags = vm.eventForm.dressCodeNotOkTags;

    if (!vm.editMode) {
      vm.eventForm.date = vm.eventForm.dateStart.clone();

      //because there is no date picker for the event date, use the event start date picker date
      vm.eventForm.date = vm.eventForm.dateStart;
    }

    if (vm.editMode) {
      if (vm.eventForm.dateStartUpdated) {
        changedValues.dateStart = vm.eventForm.dateStart;
      }
      if (vm.eventForm.dateEndUpdated) {
        changedValues.dateEnd = vm.eventForm.dateEnd;
      }
    }

    if ((('dateStart') in changedValues) || (('dateStartTime') in changedValues)) {
      changedValues.date = vm.eventForm.dateStart.clone();
      changedValues.dateStart = vm.eventForm.dateStart;
      changedValues.dateStartTime = vm.eventForm.dateStartTime;
    }

    if ((('dateEnd') in changedValues) || (('dateEndTime') in changedValues)) {
      changedValues.dateEnd = vm.eventForm.dateEnd;
      changedValues.dateEndTime = vm.eventForm.dateEndTime;
    }

    if ((('enabledOn') in changedValues) || (('enabledOnTime') in changedValues)) {
      changedValues.enabledOn = vm.eventForm.enabledOn;
      changedValues.enabledOnTime = vm.eventForm.enabledOnTime;
    }

    if (('youtube' in changedValues) || ('description' in changedValues) || ('minAge' in changedValues)) {
      changedValues.youtube = vm.eventForm.youtube;
      changedValues.description = vm.eventForm.description;
      changedValues.minAge = vm.eventForm.minAge;
    }

    const eventData = mapperService.mapEventToApi(vm.editMode ? changedValues : vm.eventForm, {
      creating: !vm.editMode
    });

    // if (vm.eventForm.isPrivate) {
    //   eventData.visibility = visibilityHelpersService.VISIBILITY_TYPES.PRIVATE.value;
    // } else {
    //   eventData.visibility = visibilityHelpersService.VISIBILITY_TYPES.PUBLIC.value;
    // }

    // if (options.publish) {
    //   eventData.visibility = visibilityHelpersService.VISIBILITY_TYPES.PUBLISHED.value;
    // }

    if (vm.editMode && Object.keys(eventData).length === 0) {
      vm.savingEvent = false;

      return Promise.resolve();
    }

    let promise;

    if (vm.editMode && vm.eventForm.enableRecurring) {
      promise = modalService.confirmationEvent({
        size: 'sm'
      });
    } else {
      promise = Promise.resolve();
    }

    return promise
      .then(result => {
        if (result && result.modalInstance) {
          result.modalInstance.close();
        }

        if ((result && result.confirm.maintainLink) && (vm.editMode && vm.eventForm.enableRecurring)) {
          eventData.disableRecurring = false;
        } else {
          eventData.disableRecurring = true;
        }

        const saveEventPromise = vm.editMode ?
          eventService.updateById(vm.eventForm.id, eventData) :
          eventService.createByOrganizationId(currentUserOrganization.id, eventData);

        return saveEventPromise
          .then(updatedEvent => {
            vm.eventForm = mapperService.mapEventToUI(updatedEvent);

            if (!vm.editMode) {
              _trackEventCreated();
            }

            alertService.success('Event saved.');

            $scope.$emit('EVENT_UPDATED', updatedEvent);
          })
          .catch(error => {
            alertService.error(sdkUtils.getErrorFromResponse(error));
          })
          .finally(() => {
            form.$setUntouched(); //reset the form values

            vm.savingEvent = false;
          });
      });
  }

  // function _unlinkEvent(eventProperties) {
  //   modalService.confirmation({
  //       modalHeader: 'Unlink event from series',
  //       modalMessage: 'Are you sure you want to unlink this event?',
  //       confirmBtnTxt: 'Unlink',
  //       confirmingBtnTxt: 'Saving...',
  //       size: 'sm'
  //     })
  //     .then(result => {
  //       if (result && result.confirm) {
  //         const eventUpdates = {
  //           disableRecurring: true
  //         };
  //
  //         eventService.updateById(eventProperties.id, eventUpdates)
  //           .then(updatedEvent => {
  //             vm.eventForm = mapperService.mapEventToUI(updatedEvent);
  //           })
  //           .catch(function (error) {
  //             alertService.error(sdkUtils.getErrorFromResponse(error));
  //
  //             jQuery('.event-save-btn').attr('disabled', false);
  //           })
  //           .finally(() => {
  //             result.modalInstance.close();
  //           });
  //       }
  //     });
  // }

  function _trackEventCreated() {
    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_EVENT, {
      category: TRACKING_EVENT_CATEGORIES.EVENTS
    });
  }

  function _getAttributionSources() {
    return attributionSourceService.listByManagementUserId(currentUser.id, {
        organizationId: currentUserOrganization.id
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }
}

AddEventCtrl.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.image',
  'jsSdk.tag',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'urlService',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService',
  'modalService',
  'jsSdk.attributionSource',
  'mapperService',
  'formHelpersService',
  'visibilityHelpersService',
  'venueService',
  'jsSdk.imgix'
];

export default AddEventCtrl;



// WEBPACK FOOTER //
// ./src/directives/addEvent/controller.js